import { useContext } from 'react'
import AuthenticatedUserContext, { User } from './AuthenticatedUser.context'

export function useUser(): User | null {
  return useContext(AuthenticatedUserContext)
}
